var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 288 c-17 -17 -17 -259 0 -276 17 -17 259 -17 276 0 17 17 17 259 0 276 -17 17 -259 17 -276 0z m228 -78 c0 -22 -23 -116 -30 -123 -4 -5 -19 -1 -33 8 -17 10 -27 13 -32 6 -10 -17 -23 -13 -30 9 -4 11 -18 26 -33 34 -20 11 -23 16 -12 20 8 3 44 16 80 30 72 27 90 31 90 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 165 c-28 -17 -40 -31 -37 -40 5 -12 9 -11 23 5 9 10 27 28 41 39 34 28 23 26 -27 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.93cfe0f896a46fb4158f0e0cb4d407f3.svg";
export { ForwardRef as ReactComponent };